import { ArrowLeftOutlined } from '@ant-design/icons'
import Page from '@components/Page/Page'
import { NotificationContentKey } from '@models/NotificationContent'
import { SettingKey } from '@models/Setting'
import { useAppDispatch } from '@store/hooks'
import { getNotificationContents } from '@store/NotificationContentReducer'
import { getSettings } from '@store/SettingReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Permission } from '@utils/permissions'
import { Button, Col, Divider, Flex, Row } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { bookingNotificationItems } from './bookingNotificationItems'

const BookingNotificationDetailPage = () => {
  const { notificationKey } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const item = bookingNotificationItems.find((i) => i.slug === notificationKey)

  useEffect(() => {
    dispatch(
      getNotificationContents([
        NotificationContentKey.RESERVATION_PLACED,
        NotificationContentKey.RESERVATION_UPDATED,
        NotificationContentKey.RESERVATION_CANCELLED,
        NotificationContentKey.NO_SHOW,
        NotificationContentKey.RESERVATION_CONFIRMATION,
      ])
    )
    dispatch(
      getSettings([
        SettingKey.NOTFICATION_RESERVATION_PLACED_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_CONFIRMATION_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_UPDATED_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_CANCELLED_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_NO_SHOW_ENABLED,
        SettingKey.MARKETING_NOSHOW_NOTIFICATION_STATUS,
        SettingKey.MARKETING_NOSHOW_NOTIFICATION_TIME,
        SettingKey.MARKETING_CONFIRMATION_TIME_IN_ADVANCE,
        SettingKey.MARKETING_CONFIRMATION_CONFIRMATION_STATUS,
      ])
    )
  }, [])

  if (!item) return null

  return (
    <Page permissions={Permission.manageSettingsBookingSettings}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Flex gap={16} align="center">
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('..')}
            />
            <PageTitle
              title={item.title}
              level={4}
              style={{ margin: 0 }}
              toolbar={item.onTestClick}
            />
          </Flex>
        </Col>
        <Divider style={{ marginBottom: 10, marginTop: 5 }} />
        <Col span={24}>
          <Row gutter={[16, 16]}>{item.content}</Row>
        </Col>
      </Row>
    </Page>
  )
}

export default BookingNotificationDetailPage
